import React from 'react'
import { Smartphone } from 'lucide-react'
import { Link, useSearchParams } from 'react-router-dom'
import MarketingSiteLayout from '../../marketing/MarketingSiteLayout'
import { checkoutProducts } from '../../content/publicPlans'

function isProductReady(product) {
  return product?.available !== false
}

function resolveProductFromQuery(raw) {
  return checkoutProducts.find((product) => product.id === raw && isProductReady(product))
    || checkoutProducts.find(isProductReady)
    || null
}

export default function CheckoutPage() {
  const [searchParams] = useSearchParams()
  const selectedProduct = resolveProductFromQuery(searchParams.get('product'))

  return (
    <MarketingSiteLayout>
      <div className="mx-auto flex min-h-[60vh] max-w-3xl items-center px-4 py-12 md:py-16">
        <section
          className="w-full rounded-3xl border border-sky-200 bg-white px-6 py-12 text-center shadow-sm sm:px-10 sm:py-16"
          aria-labelledby="mobile-payment-only-title"
        >
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-sky-50 text-brand-navy ring-1 ring-sky-200">
            <Smartphone className="h-8 w-8" aria-hidden="true" />
          </span>
          {selectedProduct?.tierName ? (
            <p className="mt-6 text-sm font-bold text-brand-sky">{selectedProduct.tierName} 구독</p>
          ) : null}
          <h1 id="mobile-payment-only-title" className="mt-2 text-3xl font-black tracking-tight text-slate-950 sm:text-4xl">
            현재 모바일 결제만 지원합니다
          </h1>
          <p className="mx-auto mt-4 max-w-md text-base leading-7 text-slate-600">
            설계EZ 모바일 앱의 <strong className="font-semibold text-slate-900">내 정보 &gt; 구독 관리</strong>에서 결제해 주세요.
          </p>
          <Link
            to="/pricing"
            className="mt-8 inline-flex min-h-[2.75rem] items-center justify-center rounded-full border border-slate-300 bg-white px-5 text-sm font-bold text-slate-800 transition hover:border-sky-300 hover:bg-sky-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2"
          >
            요금 안내로 돌아가기
          </Link>
        </section>
      </div>
    </MarketingSiteLayout>
  )
}
